import { FeatureFlag } from '@/types/featureFlag';

// Fetched once at boot by routes, so reads of these below resolve from the cache. A key set goes
// to the network if any one member is missing, so a flag asked for alongside these belongs here.
export const PATIENT_DETAILS_FLAGS = {
    hasOrders: FeatureFlag.ORDERS,
    editVisitServices: FeatureFlag.DASHBOARD_EDIT_VISIT_SERVICES_DIALOG,
    editVisitFulfillmentWindow: FeatureFlag.DASHBOARD_EDIT_VISIT_FULFILLMENT_WINDOW_DIALOG,
    episodesSupported: FeatureFlag.EPISODES_OF_CARE,
    demoCommsDrawer: FeatureFlag.DEMO_DASHBOARD_PATIENT_COMMS_DRAWER,
};
